import { AppTheme, LANGUAGE } from 'types';

interface ActionTypes {
  SET_APP_THEME: string;
  SET_APP_LANGUAGE: string;
  SET_HEADER_PANEL_EXPAND: string;
  SET_PRIVATE_TEAMBASE_MAP: string;
}

export interface PrivateTeamBaseMap {
  [userId: number]: string;
}

export const AppActionTypes: ActionTypes = {
  SET_APP_THEME: '@@SET_APP_THEME',
  SET_APP_LANGUAGE: '@@SET_APP_LANGUAGE',
  SET_HEADER_PANEL_EXPAND: '@@SET_HEADER_PANEL_EXPAND',
  SET_PRIVATE_TEAMBASE_MAP: '@@SET_PRIVATE_TEAMBASE_MAP'
};

export interface AppState {
  theme?: AppTheme;
  language?: LANGUAGE;
  privateTeamBaseMap?: PrivateTeamBaseMap;
  headerPanelExpand?: any;
}

export default AppActionTypes;
